// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import * as pointLib from '../../../common/maths/geometry/point';
import * as rectLib from '../../../common/maths/geometry/rect';
import { getSelectionMarqueeDimensions } from './selectionMarqueeUtils';

const NO_TRANSLATION = { x: 0, y: 0 };

const initialState = {
    active: false,
    appendMode: false,
    top: null,
    left: null,
    width: null,
    height: null,
    // The marquee with respect to the canvas document coordinate system
    // This is used to find the elements that are currently underneath the marquee.
    canvasDocumentMarqueeRect: {},
};

export default (DecoratedComponent) => {
    class SelectionMarqueeStateManager extends React.Component {
        constructor(props) {
            super(props);

            this.state = initialState;

            this.startPosition = {
                x: null,
                y: null,
            };
        }

        /**
         * NOTE: This takes the visual coordinates with respect to the scroll area coordinate system.
         */
        startMarqueeSelect = ({ x, y, appendMode = false }) => {
            if (this.props.disabled) return;

            this.startPosition = { x, y };
            this.setState({ active: true, left: x, top: y, appendMode });
            this.props.setSelectionMarqueeActive(true);
        };

        /**
         * NOTE: This takes the visual coordinates with respect to the scroll area coordinate system.
         */
        dragMarqueeSelectionTo = (currentPosition) => {
            const { zoomScale = 1, zoomTranslationPx = NO_TRANSLATION } = this.props;

            const { left, top, width, height } = getSelectionMarqueeDimensions(
                this.startPosition,
                currentPosition,
                this.props.containerWidth,
            );

            // Transform into canvas document position
            const canvasDocumentMarqueeStartingPoint = pointLib.difference(zoomTranslationPx, { x: left, y: top });

            let canvasDocumentMarqueeRect = {
                left: Math.max(canvasDocumentMarqueeStartingPoint.x, 0),
                top: Math.max(canvasDocumentMarqueeStartingPoint.y, 0),
                width: width + Math.min(canvasDocumentMarqueeStartingPoint.x, 0),
                height: height + Math.min(canvasDocumentMarqueeStartingPoint.y, 0),
            };

            canvasDocumentMarqueeRect = rectLib.scale(1 / zoomScale, canvasDocumentMarqueeRect);

            this.setState({ left, top, width, height, canvasDocumentMarqueeRect });
        };

        finishMarqueeSelect = () => {
            this.setState(initialState);
            this.props.setSelectionMarqueeActive(false);
        };

        render() {
            return (
                <DecoratedComponent
                    {...this.props}
                    {...this.state}
                    startMarqueeSelect={this.startMarqueeSelect}
                    dragMarqueeSelectionTo={this.dragMarqueeSelectionTo}
                    finishMarqueeSelect={this.finishMarqueeSelect}
                />
            );
        }
    }

    SelectionMarqueeStateManager.propTypes = {
        disabled: PropTypes.bool,
        setSelectionMarqueeActive: PropTypes.func,
        containerWidth: PropTypes.number,
        zoomScale: PropTypes.number,
        zoomTranslationPx: PropTypes.object,
    };

    return SelectionMarqueeStateManager;
};
